<template>
    <div class="add-or-edit-hhk-container">
        <van-nav-bar :title="isAdd ? '添加花惠卡' : '编辑花惠卡'" />
        <van-form class="hhk-form" validate-first :show-error-message="false" :show-error="true" @failed="onFailed" @submit="onSubmit">
            <van-field name="uploader" label="花惠卡图片">
                <template #input>
                    <van-uploader
                        accept="*"
                        :before-read="beforeRead"
                        v-model="form.picturesdev"
                        :after-read="afterRead"
                        :before-delete="deleteImg"
                        :deletable="preview"
                        :max-count="3"
                        :max-size="3 * 1024 * 1024"
                    />
                </template>
            </van-field>
            <div class="upload-tip">提示：请上传格式为JPG/PNG,小于3M的图片</div>
            <van-field
                class="input-special-style"
                v-model="form.discountTitle"
                name="name"
                label="优惠项目"
                placeholder="请输入优惠券项目名称"
                required
                :rules="[{ required: true, message: '请输入优惠券项目名称' }]"
            />
            <van-field
                name="isExternal"
                label="对外折扣"
                direction="horizontal"
                required
                :rules="[{ required: true, message: '请选择对外折扣' }]"
            >
                <template #input>
                    <van-radio-group v-model="form.isExternal" direction="horizontal">
                        <van-radio :name="0" checked-color="#FF6633">无</van-radio>
                        <van-radio :name="1" checked-color="#FF6633">有</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                class="input-special-style"
                v-model="form.externalDiscount"
                v-if="form.isExternal"
                name="externalDiscount"
                label="对外折扣"
                placeholder="请输入对外折扣，例如7折"
                required
                :rules="[{ required: true, message: '请输入对外折扣，例如7折' }]"
            >
                <template #right-icon>折</template>
            </van-field>
            <van-field
                class="input-special-style"
                v-model="form.internalDiscount"
                name="discountInput"
                label="花惠卡折扣"
                placeholder="请输入折扣，例如7折"
                required
                :rules="[{ required: true, message: '请输入折扣，例如7折' }]"
            >
                <template #right-icon>折</template>
            </van-field>

            <div class="submit-btn-box">
                <van-button block type="warning" native-type="submit">提交</van-button>
            </div>
        </van-form>
        <div v-if="form.audit == 2" class="up-dowm">
            <van-button v-if="form.status == 1" block type="warning" @click="submit('up')">上架</van-button>
            <van-button v-if="form.status == 0" block type="warning" @click="submit('dowm')">下架</van-button>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { updateMallOrgDiscount, addMallOrgDiscount } from '../api/index';
export default {
    data() {
        return {
            isAdd: true, // 是否是编辑
            preview: false,
            radio: false,
            form: {
                picturesdev: [],
                pictures: '',
                discountTitle: '',
                isExternal: 0,
                internalDiscount: ''
            },
            imageuHost: 'https://file.pzhszgh.cn'
        };
    },
    mounted() {
        this.isAdd = this.$route.query.isAdd === 'true';
        if (this.isAdd) {
            // 这是新增页面
            this.preview = true;
        } else {
            // 这是编辑页面
            Object.assign(this.form, JSON.parse(this.$route.query.item));
            this.beforeUrl();
        }
    },
    methods: {
        // 图片获取处理
        beforeUrl() {
            const arr = this.form.pictures.split(',');
            this.form.picturesdev = arr.map((item) => ({ url: this.imageuHost + item }));
            console.log(this.form);
        },
        deleteImg(file, detail) {
            // 删除pictures
            const array = this.form.pictures.split(',');
            array.splice(detail.index, 1);
            this.form.pictures = array.join(',');
            // 去掉首位的,
            this.form.pictures = this.form.pictures.replace(/^,|,$/g, '');

            // 删除pictures
            this.form.picturesdev.splice(detail.index, 1);
        },
        afterRead(file) {
            const formData = new FormData();
            formData.append('file', file.file);
            this.$http.post('https://file.pzhszgh.cn/file/upload?module=mall', formData).then((res) => {
                this.form.pictures =
                    this.form.pictures !== '' ? this.form.pictures + ',' + res.data.data.relativePath : res.data.data.relativePath;
            });
            console.log(this.form);
        },
        submit(e) {
            const params = {
                mallOrgDiscountID: this.form.mallOrgDiscountID,
                status: 0,
                isShelves: 1,
                phone: this.$globalData.phone1
            };
            if (e === 'up') {
                params.status = 0;
            }
            if (e === 'dowm') {
                params.status = 1;
            }
            params.isShelves = 1;
            updateMallOrgDiscount(params).then((res) => {
                Toast(res.data);
                this.$router.go(-1);
            });
        },
        onSubmit(values) {
            Object.assign(values, this.form);
            values.phone = this.$globalData.phone1;
            // 添加/编辑
            if (this.isAdd) {
                console.log('add', values);
                addMallOrgDiscount(values).then((res) => {
                    Toast(res.data);
                    this.$router.go(-1);
                });
            } else {
                console.log('edit', values);
                updateMallOrgDiscount(values).then((res) => {
                    Toast(res.data);
                    this.$router.go(-1);
                });
            }
        },
        onFailed(errorInfo) {
            console.log('failed', errorInfo);
            Toast(errorInfo.errors[0].message);
        },
        beforeRead(file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                Toast('请上传 jpg或png 格式图片');
                return false;
            }
            return true;
        }
    }
};
</script>

<style scoped lang="scss">
.hhk-form {
    ::v-deep .van-cell {
        display: block;

        .van-cell__title {
            width: 100%;
            padding-left: 10px;
            font-size: 16px;
        }
        .van-cell__value .van-field__body {
            padding: 5px 0;
        }
    }

    ::v-deep .input-special-style .van-cell__value .van-field__body {
        .van-field__control {
            height: 35px;
            background-color: #f5f5f5;
            padding: 0 10px;
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
        }
        .van-field__right-icon {
            height: 35px;
            line-height: 35px;
            background-color: #f5f5f5;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            color: #000000;
        }
    }

    .van-cell--required {
        &::before {
            left: 16px;
        }
        &::after {
            border: none;
        }
    }

    .upload-tip {
        padding: 5px 16px;
        font-size: 14px;
        color: #ff6633;
    }
    .submit-btn-box {
        padding: 16px;
        // margin-top: 50px;
        .van-button:first-child {
            margin-bottom: 20px;
        }
    }
}
.up-dowm {
    width: 340px;
    margin: 0 auto;
}
</style>
